import { TestBuyProductWithCriteria } from "@coworker/types/lib/testbuy";
import { articleFactory } from "../ObjectFactories/ArticleFactory";
import { postToTestbuyService } from "../../../../hooks/API/testbuy.service";
import { useQuery } from "@tanstack/react-query";
import {
  fetchArticleById,
  fetchPreviousTestbuyNumberOfArticles,
  fetchTestbuyArticles,
} from "./testbuy.article.api";

export const TESTBUY_ARTICLES_QUERY_KEY = "get-testbuy-articles";

export function useGetArticleById(
  testbuyKey: string,
  testbuyArticleKey: string
): {
  data: TestBuyProductWithCriteria;
  loading: boolean;
} {
  const { data: articleData, isLoading: loading } = useQuery({
    queryKey: ["use-get-article-by-id", testbuyArticleKey],
    queryFn: async () => {
      return await fetchArticleById(testbuyKey, testbuyArticleKey);
    },
    staleTime: 0,
  });

  return { data: articleData ?? articleFactory(), loading };
}

export function useTestBuyArticles(testbuyKey: string | undefined) {
  return useQuery<TestBuyProductWithCriteria[]>({
    queryKey: [TESTBUY_ARTICLES_QUERY_KEY, testbuyKey],
    queryFn: async () => await fetchTestbuyArticles(testbuyKey),
    staleTime: 0,
    enabled: !!testbuyKey,
  });
}

export async function useAddFollowUpTaskId(
  testbuyKey: string,
  articleKey: string,
  followUpTaskId: string
) {
  postToTestbuyService(
    "article/addFollowUpTaskId",
    {
      testbuyId: testbuyKey,
      articleId: articleKey,
      followUpTaskId,
    },
    () => {}
  );
}

export function useNumberOfArticles(
  storeId: string,
  area: string
): {
  numberOfArticlesForArea: number;
  loading: boolean;
} {
  const { data: noOfArticles, isLoading: loading } = useQuery({
    queryKey: ["number-of-articles", storeId, area],
    queryFn: async () => {
      if (area === "whole=whole") {
        return 5;
      }
      return await fetchPreviousTestbuyNumberOfArticles(storeId, area);
    },
  });

  return { numberOfArticlesForArea: noOfArticles?.number_of_articles, loading };
}
